import { Box, IconButton, Typography } from "@mui/material";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import CloseIcon from "@mui/icons-material/Close";
import { useRewampLocalization, useRewampT } from "../../localisation";
import { RADIO_STATUS, useRadioPlayback } from "../../context/RadioPlaybackContext";
import { bottomBarOffset } from "../../layouts/navMetrics";
import radioArt from "../../../assets/rewamp/quick-access/krishi_radio.svg";

const playerSx = (theme) => {
  const tint = theme.palette.neutral.springGold200;
  return {
    position: "sticky",
    bottom: bottomBarOffset(0),
    zIndex: theme.zIndex.appBar,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
    // The dark tint is translucent; layering it on the page background keeps scrolled content from showing through.
    backgroundColor: theme.palette.background.default,
    backgroundImage: `linear-gradient(${tint}, ${tint})`,
  };
};

const squareSx = (theme) => ({ width: theme.spacing(6), height: theme.spacing(6), flexShrink: 0 });

export default function PwaRadioMiniPlayer() {
  useRewampLocalization(["common"]);
  const tRewamp = useRewampT();
  const { status, toggle, stop } = useRadioPlayback();

  if (status === RADIO_STATUS.IDLE) return null;

  const playing = status === RADIO_STATUS.PLAYING;
  const ToggleIcon = playing ? PauseRoundedIcon : PlayArrowRoundedIcon;

  return (
    <Box sx={playerSx}>
      <Box component="img" src={radioArt} alt="" aria-hidden="true" sx={squareSx} />
      <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
        <Typography variant="callCentreTitle" component="p" noWrap sx={{ color: "neutral.headings" }}>
          {tRewamp("PWA_HOME.RADIO_TITLE")}
        </Typography>
        <Typography variant="agriCardPack" component="p" noWrap sx={{ color: "neutral.body" }}>
          {tRewamp(playing ? "PWA_HOME.RADIO_STREAMING" : "PWA_HOME.RADIO_PAUSED")}
        </Typography>
      </Box>
      <IconButton
        onClick={toggle}
        aria-label={tRewamp(playing ? "PWA_HOME.RADIO_PAUSE" : "PWA_HOME.RADIO_PLAY")}
        sx={(theme) => ({
          ...squareSx(theme),
          color: "primary.interactive",
          bgcolor: "primary.softSurface",
          "&:hover": { bgcolor: "primary.softSurface" },
        })}
      >
        <ToggleIcon aria-hidden="true" />
      </IconButton>
      <IconButton onClick={stop} aria-label={tRewamp("PWA_HOME.RADIO_CLOSE")} sx={{ color: "primary.interactive" }}>
        <CloseIcon aria-hidden="true" />
      </IconButton>
    </Box>
  );
}
